import { useState } from 'react';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';

interface ShopInsuranceAcknowledgmentOverlayProps {
  open: boolean;
  onAcknowledge: (dontShowAgain: boolean) => void;
}

export const ShopInsuranceAcknowledgmentOverlay = ({
  open,
  onAcknowledge,
}: ShopInsuranceAcknowledgmentOverlayProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  if (!open) {
    return null;
  }

  const handleAcknowledge = () => {
    onAcknowledge(dontShowAgain);
  };

  return (
    <div
      data-testid="shop-insurance-acknowledgement-overlay"
      className="absolute inset-0 z-50 flex items-center justify-center bg-black/50"
    >
      <div className="mx-4 w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <h2 className="text-lg font-semibold text-gray-900">Important Notice</h2>
        <p className="mt-3 text-sm text-gray-700">
          Initial values provided are close approximations, typically within 1% of the actual
          values. For the true value, click on "Create Quote" for the policies you're interested in.
        </p>
        <div className="mt-4 flex items-center space-x-2">
          <Checkbox
            id="dontShowAgain"
            checked={dontShowAgain}
            onCheckedChange={checked => setDontShowAgain(checked as boolean)}
          />
          <label
            htmlFor="dontShowAgain"
            className="cursor-pointer text-sm font-medium leading-none text-gray-700 peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Don't show this again
          </label>
        </div>
        <div className="mt-6">
          <Button
            onClick={handleAcknowledge}
            className="w-full"
            data-testid="shop-insurance-acknowledgement-overlay-button"
          >
            Acknowledge
          </Button>
        </div>
      </div>
    </div>
  );
};
